import React, { useState } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import LandingPageTourCard from '../Tours/LandingPageTourCard';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../shared-components/SwipperArrows/SwipperArrows';

SwiperCore.use([Navigation]);

interface RelatedProductCarouselItem {
  alt: string;
  image: string;
}

interface RelatedProduct {
  avg_rating: string;
  carousel: RelatedProductCarouselItem[];
  city: string;
  country: string;
  duration: number;
  highlight: string;
  id: string;
  name: string;
  objectID: string;
  price: string;
  private: boolean;
  reviews_count: number;
  slug: string;
  snippet: string;
}

interface RelatedToursProps {
  relatedProducts: RelatedProduct[]; // Array of related products
}

const RelatedTours: React.FC<RelatedToursProps> = ({ relatedProducts }) => {
  const [isLastSlide, setIsLastSlide] = useState<boolean>(false);
  const [isFirstSlide, setIsFirstSlide] = useState<boolean>(false);

  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };

  const handleSwiperInit = (swiper: any) => {
    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <div className="flex flex-col justify-between pt-4 pb-6 w-full max-w-[100vw]">
      <div className="flex py-4 justify-between items-center">
        <h2 className="text-lg lg:text-xl font-semibold text-start">
          Nearby Tours
        </h2>
        <div id="slider-btn" className="flex gap-2 items-center">
          <div className="prevSlide">
            <LeftSwipperArrows isFirstSlide={isFirstSlide} />
          </div>
          <div className="nextSlide">
            <RightSwipperArrows isLastSlide={isLastSlide} />
          </div>
        </div>
      </div>

      <Swiper
        className="related-tours-swiper w-full px-4 sm:px-0"
        spaceBetween={20}
        slidesPerView={1} // Force 1 slide as default
        onSlideChange={(swiper: any) => handleSlideChange(swiper)}
        onInit={(swiper: any) => handleSwiperInit(swiper)}
        navigation={{
          nextEl: '.nextSlide',
          prevEl: '.prevSlide'
        }}
        breakpoints={{
          // Explicitly set breakpoints
          320: {
            slidesPerView: 1, // Mobile devices
            spaceBetween: 10
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          640: {
            slidesPerView: 2, // Small tablets
            spaceBetween: 15
          },
          768: {
            slidesPerView: 2, // Tablets
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3, // Laptops
            spaceBetween: 20
          },
          1280: {
            slidesPerView: 4, // Large screens
            spaceBetween: 20
          }
        }}
      >
        {relatedProducts?.length > 0 ? (
          relatedProducts.map((product, index) => (
            <SwiperSlide key={product.id}>
              <LandingPageTourCard tourCard={product} index={index + 1} />
            </SwiperSlide>
          ))
        ) : (
          <div className="flex justify-start text-[14px] md:text-base items-center h-12">
            No related tours found.
          </div>
        )}
      </Swiper>
    </div>
  );
};

export default RelatedTours;
